import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, compose } from 'redux';
import { reactReduxFirebase } from 'react-redux-firebase';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import App from './App';
import MainPage from './pages/main-page';
import SectionPage from './pages/section-page';
import './index.css';
import './semantic/dist/semantic.min.css';
import rootReducer from './reducers';

const firebaseConfig = {
  apiKey: 'AIzaSyDsGCMQLa0J6fI5mey0-LBgTIqhjD1dY_E',
  authDomain: 'westney-bible-study.firebaseapp.com',
  databaseURL: 'https://westney-bible-study.firebaseio.com/',
  storageBucket: 'gs://westney-bible-study.appspot.com/',
};

const config = {
  userProfile: 'users',
};

const createStoreWithFirebase = compose(
  reactReduxFirebase(firebaseConfig, config),
)(createStore);

const store = createStoreWithFirebase(rootReducer, {});

render(
  <Provider store={store}>
    <Router history={browserHistory}>
      <Route path="/" component={App}>
        <IndexRoute component={MainPage} />
        <Route path="/(:section)" component={SectionPage} />
      </Route>
    </Router>
  </Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js